module.exports = __webpack_public_path__ + "static/PGA_Event-23-a88aa4ef596d251867f181f9a82a54ef.jpg";